<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-container fluid>
                                <v-row>
                                    <v-col
                                            v-for="n in 10"
                                            :key="n"
                                            class="d-flex child-flex"
                                            cols="6"
                                    >
                                        <v-card flat tile class="d-flex">
                                            <v-img
                                                    :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                                                    :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                            >
                                                <template v-slot:placeholder>
                                                    <v-row
                                                            class="fill-height ma-0"
                                                            align="center"
                                                            justify="center"
                                                    >
                                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="8">
                        <v-img
                                :src="'https://cdn.vuetifyjs.com/images/cards/docks.jpg'"
                                :lazy-src="'https://cdn.vuetifyjs.com/images/cards/docks.jpg'"
                                aspect-ratio="1"
                                class="grey lighten-2"
                        >
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <h1 class="font-weight-bold display-2">Product {{ lang }}</h1>
                <p class="subtitle-2">
                    <span v-if="lang == 'en' ">Brand</span>
                    <span v-if="lang == 'pt' ">Marca</span>
                    <span v-if="lang == 'en' ">Marca</span>
                    :
                    <span class="font-weight-bold">Brand1</span>
                </p>
                <p class="font-weight-medium display-1 accent--text">$15.00</p>
                <div class="mb-6">
                    <div>
                        <strong v-if="lang == 'en' ">Availability</strong>
                        <strong v-if="lang == 'pt' ">Disponibilidade</strong>
                        <strong v-if="lang == 'es' ">Disponibilidad</strong>
                        : In Stock
                    </div>
                    <div>
                        <strong v-if="lang == 'en' ">Product Code</strong>
                        <strong v-if="lang == 'pt' ">Código do produto</strong>
                        <strong v-if="lang == 'es' ">Código de producto</strong>
                        : 13548370165802
                    </div>
                </div>
                <v-col cols="12" md="4">
                    <v-select
                            :items="quanty"
                            label="Quantity"
                            :value="'1'"
                            v-if="lang == 'en' "
                    ></v-select>
                    <v-select
                            :items="quanty"
                            label="Cantidad"
                            :value="'1'"
                            v-if="lang == 'es' "
                    ></v-select>
                    <v-select
                            :items="quanty"
                            label="Quantidade"
                            :value="'1'"
                            v-if="lang == 'pt' "
                    ></v-select>
                </v-col>
                <div class="row mb-8 row--dense">
                    <div class="col-md-auto col-12">
                        <button type="button" class="mb-6 mb-md-0 v-btn v-btn--contained theme--light v-size--x-large text-none orange" style="min-width: 160px;">
                            <span v-if="lang == 'en' ">Add To Cart</span>
                            <span v-if="lang == 'pt' ">Adicionar ao carrinho</span>
                            <span v-if="lang == 'es' ">Añadir a la cesta</span>

                        </button>
                    </div>
                </div>
            </v-col>
            <v-col cols="12">
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer at vehicula nulla, id tincidunt erat. Nam non gravida justo. Vivamus eu massa sed est sagittis auctor non sit amet velit. Sed eget tellus lacus. Sed sit amet sagittis nulla. Aliquam arcu turpis, cursus vitae consequat nec, blandit ut enim. Etiam porta, odio nec egestas efficitur, ante purus placerat urna, vitae suscipit sapien neque a tortor. Donec volutpat aliquam luctus. Nunc ac mattis diam. Mauris pulvinar varius urna eu viverra. Maecenas ac tincidunt urna, id aliquet justo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Praesent iaculis mauris tortor, non aliquam nulla efficitur eget. Etiam euismod tincidunt neque, quis placerat urna sodales ornare. Suspendisse id efficitur nunc.
                </p>
                <p>
                    In laoreet sagittis orci, vel efficitur ante viverra in. Proin eu dui molestie, suscipit felis eleifend, cursus lacus. Aliquam consequat eros sed mi lobortis, vel blandit eros pretium. Phasellus consectetur ipsum vestibulum, faucibus libero sed, iaculis ipsum. Nullam tellus nisi, auctor ac sapien et, porttitor fermentum velit. Nunc lobortis massa velit. Phasellus nunc nunc, commodo posuere scelerisque sit amet, rhoncus vel felis. Integer eu tortor ac mauris varius fringilla. Sed feugiat a lorem ac imperdiet. Integer sodales, urna nec facilisis efficitur, risus quam porta odio, sed tincidunt ante nulla mattis dui. Fusce elit felis, tempor id libero eu, mattis finibus urna.
                </p>
                <p>
                    Suspendisse fermentum ex vitae nibh ultrices iaculis. Aliquam pulvinar turpis at pharetra semper. Praesent elementum, augue a aliquam rutrum, enim orci accumsan lorem, non consectetur lorem metus in justo. Aliquam eu faucibus velit, id vulputate orci. Donec quis magna arcu. Mauris nec lectus commodo mauris fermentum blandit. Fusce nec neque et odio lacinia rutrum. Aliquam sollicitudin libero nunc, sed vehicula ante cursus sed. Nulla quam eros, congue a nisl sed, consectetur convallis enim. Cras condimentum, ex id dapibus scelerisque, odio lacus porta nisi, a vulputate leo massa in lectus. Donec imperdiet consectetur nibh. Nulla non metus et arcu ultricies blandit nec a velit. Integer ultricies eget tortor vel feugiat. Fusce ornare, mauris eget vehicula iaculis, nisl enim faucibus dui, in aliquam dolor erat ultrices ipsum. Morbi condimentum eget tellus nec condimentum.
                </p>
                <p>
                    Sed venenatis dolor sit amet convallis scelerisque. Suspendisse dapibus blandit mi, non facilisis lorem lacinia eu. Curabitur est orci, dapibus ut erat in, aliquam maximus nibh. Phasellus bibendum eget arcu eu vulputate. Vestibulum et sapien ultrices, facilisis magna vel, porttitor nunc. Maecenas leo massa, pretium ullamcorper urna efficitur, auctor tempor est. Vivamus fermentum suscipit hendrerit. Donec blandit ut urna et hendrerit. Sed interdum placerat pharetra. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Fusce ultrices neque lectus, eget pulvinar magna bibendum sed. Fusce sit amet felis iaculis, ornare urna at, cursus massa.
                </p>
                <p>
                    Curabitur eu vulputate ex. Cras ut velit nec massa pellentesque lobortis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam ante nisi, luctus nec efficitur vitae, pretium eu libero. Aliquam at justo pulvinar, auctor ex vel, vestibulum nisi. Donec cursus sollicitudin tincidunt. Aliquam et mi cursus, ultrices nisl quis, pellentesque turpis. Donec pellentesque sollicitudin urna eu interdum. Cras fermentum quis nulla quis faucibus. Nullam tincidunt felis sed lobortis tristique.
                </p>
            </v-col>
            <v-col cols="12">
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'en' ">You Might Also Like</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'pt' ">Você pode gostar também</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'es' ">También podría gustarte</p>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/produto'+index"
                        >
                            <v-img
                                    class="white--text align-end"
                                    src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary">
                                <div>Ut gravida, metus sit amet sodales consequat, quam quam commodo libero, at gravida elit est ut nisi.</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    $9.99
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        metaInfo () {
            return {
                title: 'Product'
            }
        },
        data () {
            return {
                lang: "en",
                quanty: ['1', '2', '3', '4','5','6','7','8','9','10'],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                email:false,
                customer:{
                    email:""
                },
                loading:{
                    login:false
                },
                products: [
                    {
                        name: 'Product 1',
                    },
                    {
                        name: 'Product 2',
                    },
                    {
                        name: 'Product 3',
                    },
                    {
                        name: 'Product 4',
                    },
                ],
            }
        },
        methods:{
            init() {
                var  page = window.location.pathname.split('/');
                if(page[1] == 'pt' || page[1] == 'es'){
                    this.lang = page[1];
                }else{
                    this.lang = 'en';
                }
            }
        },
        mounted(){
            var self = this;
            setInterval(function(){
                    self.init();
                }, 1000
            );
        }
    }
</script>